import React from 'react';
import MapForm from './MapForm';
import { modifyTemplate } from '../../../api';
import { connect } from 'react-redux';
import { merge } from '@its/util';
import {
  onModificationSuccess,
  adjustStartPositions,
  setSpecialFeatures,
} from '../util';

const onSubmit = (template, map, values) => {
  const result = merge({}, template);
  result.displayTemplateMaps = [...template.displayTemplateMaps];
  const resultMap = merge(map, values);
  for (const i in result.displayTemplateMaps) {
    if (result.displayTemplateMaps[i].id === resultMap.id) {
      result.displayTemplateMaps[i] = resultMap;
      setSpecialFeatures(result.displayTemplateMaps[i], values);
      delete result.displayTemplateMaps[i].multiCharacter;
      delete result.displayTemplateMaps[i].sliding;
      delete result.displayTemplateMaps[i].intermittence;
      delete result.displayTemplateMaps[i].indicator;
    }
  }
  adjustStartPositions(result);
  return result;
};

const mapStateToProps = (state) => (
  {
    name: 'modifyMap',
    request: modifyTemplate(state.app.templates.maps.detail.id),
    initialValues: state.app.templates.maps.detail,
    onSubmit: onSubmit.bind(null, state.app.templates.detail, state.app.templates.maps.detail),
    onSuccess: onModificationSuccess,
    appBar: {
      title: 'MAP',
      navigateBack: true,
    },
  }
);

export default connect(
  mapStateToProps
)(MapForm);



/** WEBPACK FOOTER **
 ** ./src/routes/Template/Map/Map.js
 **/